enum SummaryActuality {
    Past = "Past",
    Present = "Present",
    Future = "Future"
}

export default SummaryActuality;